import {states} from '../commons/constants/portaro.constants';
import type {Auth} from 'typings/portaro.be.types';
import type {LoginFormState} from './login';
import type ModalConversationService from '../commons/conversation/modal-conversation.service';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {PayloadActionResponse} from 'typings/portaro.fe.types';

export default class MainLoginFormService {
    public static serviceName = 'mainLoginFormService';
    private form: LoginFormState;

    /*@ngInject*/
    constructor(private modalConversationService: ModalConversationService) {
        this.form = {
            state: states.NORMAL,
            error: null
        };
    }

    public async openForm(): Promise<Auth> {
        const loginSuccessResponse = await this.openModalLoginForm();
        return loginSuccessResponse.payload;
    }

    private closeForm() {
        this.clearError();
    }

    @ngAsync()
    private async openModalLoginForm(): Promise<PayloadActionResponse<Auth>> {
        try {
            return await this.modalConversationService.openModalWindowAndGetFinishedResponse<PayloadActionResponse<Auth>>('LoginForm');
        } finally {
            this.closeForm();
        }
    }

    public isProcessing() {
        return this.form.state === states.PROCESSING;
    }

    public startProcessing() {
        this.form.state = states.PROCESSING;
    }

    public endProcessing() {
        this.form.state = states.NORMAL;
    }

    public isError() {
        return !!this.form.error;
    }

    public getError() {
        return this.form.error;
    }

    public setError(err) {
        this.form.error = err;
    }

    public clearError() {
        this.form.error = null;
    }
}
